import "./Pricing.scss";
import Buttons from '../../components/Buttons/Buttons';


const Pricing = ({stats, handleChange, onClickBtn})=>{
    
    const formatNumber = (num) => {
        if (!num) return "0";
        return parseFloat(num).toLocaleString("en-US", {maximumFractionDigits: 2});
    };
    
    return (
        <div className="gallery">
            <h3 className="gallery__headTitle">Compute Annual Cost of your CEMS</h3>
            <div className="gallery__parent">
                <div className="gallery__wrapper-first">
                    <h4 className="gallery__title">CEMS </h4>
                    <p className="gallery__unit col1">Cost per Unit</p>
                    <p className="gallery__unit">Unit (Quantity)</p>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">
                        Installed Price for CEMS <span className="info__icon">i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">CEMS Installed Cost: Please enter approximate installed cost of CEMS hardware. This cost is broken down over a 10 year expected CEMS Lifespan.</p>
                        </div>
                    </h4>
                    
                    <div className="gallery__unit">
                        $&nbsp;<input className="gallery__input" type="text" name="cems" value={formatNumber(stats.cems)} onChange={handleChange}></input>
                    </div>
                    <div className="gallery__unit">
                        <select className="gallery__percent" name="cemsUnit" value={stats.cemsUnit} onChange={handleChange}>
                            <option value="0%">Select</option>
                            <option value="5%">5%</option>
                            <option value="6%">6%</option>
                            <option value="7%">7%</option>
                            <option value="8%">8%</option>
                            <option value="9%">9%</option>
                            <option value="10%">10%</option>
                        </select>
                        <p className="unit-text">Depreciation % </p>
                    </div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">RATA Test <span className="info__icon"> i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">Relative Accuracy Test Audit Tests: Please enter the approximate cost per RATA Test conducted and the frequency of RATA tests conducted per year on your CEMS.</p>
                        </div>
                    </h4>
                    <div className="gallery__unit">
                        $&nbsp;<input className="gallery__input" type="text" name="rata" value={formatNumber(stats.rata)} onChange={handleChange}></input>
                    </div>
                    <div className="gallery__unit">
                        <select className="gallery__percent" name="rataUnit" value={stats.rataUnit} onChange={handleChange}>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                        <p className="unit-text">Annual tests </p>
                    </div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">CGA Tests (3rd Party) <span className="info__icon"> i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">Cylinder Gas Audit Tests: Please enter the approximate cost per CGA Test conducted and the frequency of CGA tests conducted per year on your CEMS.</p>
                        </div>
                    </h4>
                    <div className="gallery__unit">
                        $&nbsp;<input className="gallery__input" type="text" name="cga" value={formatNumber(stats.cga)} onChange={handleChange}></input>
                    </div>
                    <div className="gallery__unit">
                        <select className="gallery__percent" name="cgaUnit" value={stats.cgaUnit} onChange={handleChange}>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                        </select>
                        <p className="unit-text">Annual tests</p>
                    </div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">Daily Zero & Span Drift Test <span className="info__icon"> i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">Please enter the approximate hourly cost of your onsite personnel and the average number of hours spent per day conducting zero and span drift tests.</p>
                        </div>
                    </h4>
                    <div className="gallery__unit">
                        $&nbsp;<input className="gallery__input" type="text" name="daily" value={formatNumber(stats.daily)} onChange={handleChange}></input> <p className="unit-text">Labor rate per hour</p>
                    </div>
                    <div className="gallery__unit">
                        <input className="gallery__input-ndCol" type="text" name="dailyUnit" value={formatNumber(stats.dailyUnit)} onChange={handleChange}></input> <p className="unit-text">Hours per test</p>
                    </div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">Typical Maintenance <span className="info__icon"> i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">Manufacturers recommend allocating 5-10% of the CEMS unit's cost per year for maintenance. Please enter the approximate percentage for your CEMS annual maintenance cost.</p>
                        </div>
                    </h4>
                    <div className="gallery__unit">
                    $&nbsp;<input className="gallery__input fix" name="maintenanceCost" value={formatNumber(stats.maintenanceCost)} disabled></input>
                    </div>
                    <div className="gallery__unit">
                        <select className="gallery__percent" name="maintenanceUnit" value={stats.maintenanceUnit} onChange={handleChange}>
                            <option value="0%">Select</option>
                            <option value="5%">5%</option>
                            <option value="6%">6%</option>
                            <option value="7%">7%</option>
                            <option value="8%">8%</option>
                            <option value="9%">9%</option>
                            <option value="10%">10%</option>
                        </select>
                    </div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title">Annual Cost of DAS <span className="info__icon"> i</span>
                        <div className="info__tips">
                            <p className="info__tooltip">Data Acquisition System: Please enter the annual cost of your Data Acquisition System.</p>
                        </div>
                    </h4>
                    <div className="gallery__unit">
                        $&nbsp;<input className="gallery__input" type="text" name="das" value={formatNumber(stats.das)} onChange={handleChange}></input>
                    </div>
                    <div className="gallery__unit col1"><input className="gallery__input fix" type="text" name="dasUnit" value="1" disabled></input> <p className="unit-text">Year</p></div>
                </div>
                <div className="gallery__wrapper">
                    <h4 className="gallery__title cost"> </h4>
                    <div className="gallery__unit cost">
                    </div>
                    <p className="gallery__unit">Annual Cost:<strong>&nbsp;$ {formatNumber(stats.totalAcost)}</strong></p>
                </div>
            </div>
            <Buttons buttonText={"Next"} onClick={onClickBtn}/>
        </div>
    );
}

export default Pricing;